import { t } from "@lingui/core/macro";

export function validatePort(value: number) {
    return !(value >= 1 && value <= 65535) ? t`Port must be between 1 and 65535` : undefined;
}
